import { Link } from 'react-router-dom';
import ImageLinkBtn from './ImageLinkBtn';
import processingBtn from '../../assets/processing-btn.webp';
import treasureBtn from '../../assets/treasure-btn.webp';
import analyticsBtn from '../../assets/analytics-btn.webp';
// import archivesBtn from '../../assets/archives-btn.webp';

export default function ImageLinks() {

return (
  <div>
    <Link className="tooltip" to='/cats/merchant/accession'>
      <ImageLinkBtn image={processingBtn} alt="Processing Button" width="40px" />
      <span className="tooltip-text">Accessions</span>
    </Link>
    <Link className="tooltip" to='/cats/merchant/analytics'>
      <ImageLinkBtn image={analyticsBtn} alt="Analytics Button" width="40px" />
      <span className="tooltip-text">Analytics</span>
    </Link>
    <Link className="tooltip" to='/cats/merchant/assets'>
      <ImageLinkBtn image={treasureBtn} alt="Treasure Button" width="40px" />
      <span className="tooltip-text">Assets</span>
    </Link>
    {/* <Link className="tooltip" to='/cats/merchant/archive'>
      <ImageLinkBtn image={archivesBtn} alt="Archives Button" width="40px" />
      <span className="tooltip-text">x</span>
    </Link> */}
  </div>
  )
}